window.runPlatformChanged = () => {
    runShowConditionalFields();
    runRequestAdjustReadLengths();
}

window.runShowConditionalFields = () => {
    $(".conditional").hide()
    platform = $('#run_platform :selected').text().split(' ')[0].toLowerCase().split('-')[0];
    $(".conditional.".concat(platform)).show()
}

window.runRequestAdjustReadLengths = () => {
    platform = $('#run_platform :selected').text();
    if (platform.match("Seq")) { //platform is illumina
        r = $('#run_read_length').get(0);
        orig_read_length = r.value
        while(r.options.length) { r.remove(0); } // delete all the options
        options = r.options;
        options.length = 1;
        for (i = 0; i < read_lengths.length; ++i) {
            if (read_lengths[i][0] == platform) {
                options[options.length] = new Option(read_lengths[i][1]);
            }
        }
        r.value = orig_read_length // try to reselect the old read length
    }
}
